export default {
    compact: {
        about: 'About',
        archives: 'Archives',
        explore: 'Explore',
        feedback: 'Feedback',
        friends: 'Friends',
        hiddenModels: 'Hidden',
        home: 'Home',
        logIn: 'Log In',
        logOut: 'Log Out',
        mail: 'Mail',
        messages: 'Messages',
        more: 'More',
        myAccount: 'Account',
        news: 'News',
        notes: 'Notes',
        privateGallery: 'Private Gallery',
        recommendations: 'Models You May Like',
        rooms: 'Rooms',
        settings: 'Settings',
        signUp: 'Sign Up',
        support: 'Support',
    },
    expanded: {
        about: 'About',
        archives: 'Chat Archives',
        explore: 'Explore',
        feedback: 'Feedback',
        friends: 'Friends',
        hiddenModels: 'Hidden Models',
        ignoredModels: 'Ignored Models',
        home: 'Home',
        logIn: 'Log In',
        logOut: 'Log Out',
        mail: 'MFC Mail',
        messages: 'Messages',
        more: 'More',
        myAccount: 'My Account',
        news: 'News Feed',
        notes: 'My Notes',
        privateGallery: 'Private Gallery',
        recommendations: 'Models You May Like',
        rooms: 'Rooms',
        settings: 'Settings',
        signUp: 'Free Account',
        support: 'Support',
    },
    tooltips: {
        about: 'About MyFreeCams',
        archives: 'Archived Private Shows and Chat Logs.',
        explore: 'Explore online models by interests.',
        feedback: 'Provide Feedback',
        friends: 'View and manage your friends.',
        hiddenModels: 'Manage Hidden Models',
        ignoredModels: 'Manage Ignored Models',
        home: 'View online models',
        logIn: 'Login to your account.',
        logOut: 'Log out of your account.',
        mail: 'Click here to read and send mail to other MFC members.',
        messages: 'View your private messages.',
        more: 'View more available menu options.',
        myAccount: 'View Settings and Options for your account.',
        news: 'Recent News',
        notes: 'User Notepad.',
        privateGallery: 'Private Gallery',
        recommendations: 'Models You May Like',
        rooms: 'View your active rooms.',
        settings: 'View and modify settings for your model list.',
        signUp: 'Register for your free account.',
        support: 'Contact Us',
    },
}
